export const range = (start: number, end: number) =>
  [...Array(end - start + 1).keys()].map((index: number) => start + index);
